import { executeScripts, registerComponent } from "helpers";
import WYATTElement from "wyatt";

/**
 * @param {HTMLElement[]} items
 * @returns {HTMLElement[]}
 */
function shuffleItems(items) {
  const shuffled = [...items];

  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled;
}

registerComponent(
  "perfect-pairings",
  class PerfectPairings extends WYATTElement {
    constructor() {
      super();

      this.initialized = false;

      if (this.config.designMode) {
        this.renderPairings();
        return;
      }

      const observer = new IntersectionObserver(this.handleIntersection, {
        rootMargin: "0px 0px 200px 0px",
      });

      observer.observe(this);
    }

    handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting || this.initialized) {
        return;
      }

      observer.unobserve(this);
      this.renderPairings();
    };

    renderPairings() {
      if (this.initialized) {
        return;
      }

      const source = this.querySelector("[data-perfect-pairings-source]");

      if (!source) {
        return;
      }

      const temp = document.createElement("div");
      temp.appendChild(source.content.cloneNode(true));

      const slider = temp.querySelector("[data-slider]");

      if (!slider) {
        return;
      }

      const slides = Array.from(
        slider.querySelectorAll("[data-perfect-pairings-slide]"),
      );
      const limit = this.config.limit ?? 8;
      const selected = shuffleItems(slides).slice(0, limit);

      slider.replaceChildren(...selected);

      const output = this.querySelector("[data-perfect-pairings-output]");

      if (!output) {
        return;
      }

      output.replaceChildren(...temp.childNodes);

      this.initialized = true;
      this.setAttribute("ready", "");
      executeScripts(output);
    }
  },
);
